import { A9Service } from 'components/system/angular';
import { AbstractDataProviderV2, ActionTypes, IDataProviderV2, IResourceParams } from 'components/system/data-provider';
import { RsCustomerGolfInfo } from './types/RsCustomerGolfInfo';

export type ICustomerGolfDataProvider = IDataProviderV2<{}, RsCustomerGolfInfo>;

@A9Service('customerGolfDataProvider')
export class CustomerGolfDataProvider extends AbstractDataProviderV2<{}, RsCustomerGolfInfo> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{id}/golf');
    }

    public update(
        item: {},
        resourceParams: IResourceParams = {},
        cancel: Promise<void> = null,
        stealth: boolean = false,
        doPackItem: boolean = true
    ): Promise<RsCustomerGolfInfo> {
        return super.update(item, resourceParams, cancel, stealth, doPackItem).then(resulte => {
            this.notify({ type: ActionTypes.Update, hash: `middle://rs/customers/${resourceParams.id}/stat/dash` }, true);
            return resulte;
        });
    }
}
